export const SEASON = {
  CURRENT: 2025,
  PRIOR: 2024,
};

export const TAX_YEAR = {
  CURRENT: 2024,
  PRIOR: 2023,
};
